import { create } from 'zustand';

import { CommonModalInitialState, CommonModalType } from 'models/common/CommonModal';
import { DefaultTFuncReturn, t } from 'i18next';
import { useTranslation } from 'react-i18next';

interface CommonModalState {
  modalType: CommonModalType;
  isOpen: boolean;
  title: string | DefaultTFuncReturn;
  content: JSX.Element | string | DefaultTFuncReturn;
  showCallbackResult: boolean;
  isLineBreak: boolean;
  yesCallback?: () => any;
  noCallback?: () => any;
  setCommonModalStateWhenModalOpen: (commonModalInitialState: CommonModalInitialState) => void;
  setCommonModalStateWhenModalClose: () => void;
  autoClose?: boolean | (() => boolean);
}

export const useCommonModalStore = create<CommonModalState>((set, get) => {
  return {
    modalType: 'alert',
    isOpen: false,
    title: '',
    content: '',
    showCallbackResult: false,
    isLineBreak: false,
    autoClose: true,
    setCommonModalStateWhenModalOpen: (commonModalInitialState: CommonModalInitialState) => {
      const defaultTitle = '';
      set({
        ...commonModalInitialState,
        isOpen: true,
        title: commonModalInitialState.title ?? defaultTitle,
        autoClose: commonModalInitialState.autoClose ?? true,
      });
    },
    setCommonModalStateWhenModalClose: () => {
      set({
        isOpen: false,
        modalType: 'alert',
        content: '',
        yesCallback: undefined,
        noCallback: undefined,
        autoClose: true,
        // showCallbackResult: false,
      });
    },
  };
});
